<template>
  <div class="users">
    <div>
      <v-btn @click="exportUserData">Export Users</v-btn>
    </div>
    <div class="users-filter-set">
      <!-- <v-textarea type="text" placeholder="Search title.."/> -->
      <user-search-input @query-updated="handleNameQueryUpdated"></user-search-input>
      <user-group-selector @groups-selected="handleGroupsSelected"></user-group-selector>
    </div>
    <v-data-table
      :headers="headers"
      :items="users"
      :rows-per-page-items='[10, 5, {text: "Test", value: -1}]'
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.first_name }}</td>
        <td>{{ props.item.last_name }}</td>
        <td>{{ props.item.user_groups }}</td>
        <td>{{ props.item.valid_records_amt }}</td>
        <td>{{ props.item.all_records_amt }}</td>
        <td>
          <router-link
            :to="{ path: buildDetailsLink(props.item.id) }">
            {{ $t('user.view') }}
          </router-link>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// Render a list of users
import UserGroupSelector from './UserGroupSelector.vue'
import UserSearchInput from './UserSearchInput.vue'
import UserRepository from '../../repositories/UserRepository.js'
import events from '../../services/events'

export default {
  components: {
    UserGroupSelector,
    UserSearchInput
  },
  data () {
    return {
      value: [],
      headers: [
          {text: 'First Name', value: 'first_name'},
          {text: 'Last Name', value: 'last_name'},
          {text: 'User groups', value: 'user_groups'},
          {text: '# Valid Vids', value: 'valid_records_amt'},
          {text: '# Vids', value: 'all_records_amt'},
          {text: 'View', value: 'link'}
      ],
      users: [],
      userFilters: {
        group: '',
        name_query: ''
      }
    }
  },
  mounted () {
    this.fetchUserListData()
  },
  methods: {
    fetchUserListData () {
      let getParams = {
        usergroup: this.userFilters.group,
        full_name: this.userFilters.name_query
      }
      UserRepository.fetchUsersList(getParams).then(users => {
        this.users = users
        // this.loading = false
      })
      .catch(error => {
        // this.loading = false
        events.emit('error', error)
      })
    },
    exportUserData () {
      UserRepository.exportAllUsers()
    },
    handleGroupsSelected (chosenGroup) {
      this.userFilters.group = chosenGroup.slug
      this.fetchUserListData()
    },
    handleNameQueryUpdated (query) {
      console.log(query)
      this.userFilters.name_query = query
      this.fetchUserListData()
    },
    buildDetailsLink (pk) {
      return `user/${pk}/`
    }
  },
  computed: {
    userGroups () {
      if (this.$store.state.groups) {
        let groups = this.$store.state.groups.map(x => x.groups).flat()
        return groups
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// UsersList.vue?4f73d45c